import { getRefPageLocalStorage } from "shared/helpers/ref-page";
import {
  AdvanceButtonClickEventName,
  DistroButtonClickEventName,
  HomeButtonClickEventName,
  LoginButtonClickEventName,
  QuincyButtonClickEventName,
  QuizButtonClickEventName,
  SignUpButtonClickEventName,
} from "./button-click-event-name";
import { LoginErrorEventName } from "./error-event-name";

const platformContext = "S4A";
const screenViewedEventName = "ScreenViewed";
const clickButtonEventName = "ClickButton";

export const dataLayerEventAcesso = (user: any) => {
  if (user) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      email: user.login,
      userId: user.cognitoUsername,
      time:
        user.userTeam?.length > 0
          ? user.userTeam[0].team?.displayName
          : "Sem time associado",

      event: "acesso",
    });
  }
};

export const dataLayerEvent = (event: string, params: any) => {
  const ref = getRefPageLocalStorage();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...params,
    ref,
  });
};

interface TagManagerEvent {
  screenName: string;
  businessContext: string;
  platformContext: string;
}

interface PageViewEvents {
  Home: {
    S4A_HOME_UNDIAGNOSED: TagManagerEvent;
    S4A_HOME_DIAGNOSED: TagManagerEvent;
  };
  Quiz: {
    S4A_QUIZ_GENERAL_DATA: TagManagerEvent;
    S4A_QUIZ_PLATFORMS_CONNECT: TagManagerEvent;
    S4A_QUIZ_ANALYSIS_LOADING: TagManagerEvent;
  };
  Login: {
    S4A_LOGIN: TagManagerEvent;
  };
  SignUp: {
    S4A_SIGN_UP: TagManagerEvent;
    S4A_SIGN_UP_VERIFICATION: TagManagerEvent;
  };
  Advance: {
    S4A_ADVANCE_INDEX: TagManagerEvent;
    S4A_RELEASES_SELECTION: TagManagerEvent;
    S4A_ADVANCE_PROPOSAL: TagManagerEvent;
    S4A_ADVANCE_FORM: TagManagerEvent;
    S4A_WAITING_SIGNATURE: TagManagerEvent;
    S4A_ADVANCE_CONFIRMATION: TagManagerEvent;
    S4A_SIGNATURE_CONFIRMED: TagManagerEvent;
    S4A_ADVANCE_WAITING_MERGE: TagManagerEvent;
  };
  Distro: {
    S4A_DISTRO_SIGN: TagManagerEvent;
    S4A_DISTRO_FORM: TagManagerEvent;
  };
  Hero: {
    S4A_HERO: TagManagerEvent;
    S4A_HERO_DETAILS: TagManagerEvent;
    S4A_HERO_SIGN_UP: TagManagerEvent;
    S4A_HERO_VERIFICATION: TagManagerEvent;
    S4A_HERO_GREETINGS: TagManagerEvent;
    S4A_HERO_PORTAL: TagManagerEvent;
    S4A_HERO_GOODBYE: TagManagerEvent;
  };
  Quincy: {
    QUINCY_HOME: TagManagerEvent;
  };
}

export const tagManagerEvent: PageViewEvents = {
  Home: {
    S4A_HOME_UNDIAGNOSED: {
      screenName: "S4A_HOME_UNDIAGNOSED",
      businessContext: "HOME",
      platformContext,
    },
    S4A_HOME_DIAGNOSED: {
      screenName: "S4A_HOME_DIAGNOSED",
      businessContext: "HOME",
      platformContext,
    },
  },
  Quiz: {
    S4A_QUIZ_GENERAL_DATA: {
      screenName: "S4A_QUIZ_GENERAL_DATA",
      businessContext: "QUIZ",
      platformContext,
    },
    S4A_QUIZ_PLATFORMS_CONNECT: {
      screenName: "S4A_QUIZ_PLATFORMS_CONNECT",
      businessContext: "QUIZ",
      platformContext,
    },
    S4A_QUIZ_ANALYSIS_LOADING: {
      screenName: "S4A_QUIZ_ANALYSIS_LOADING",
      businessContext: "QUIZ",
      platformContext,
    },
  },
  Login: {
    S4A_LOGIN: {
      screenName: "S4A_LOGIN",
      businessContext: "LOGIN",
      platformContext,
    },
  },
  SignUp: {
    S4A_SIGN_UP: {
      screenName: "S4A_SIGN_UP",
      businessContext: "SIGN_UP",
      platformContext,
    },
    S4A_SIGN_UP_VERIFICATION: {
      screenName: "S4A_SIGN_UP_VERIFICATION",
      businessContext: "SIGN_UP",
      platformContext,
    },
  },
  Advance: {
    S4A_ADVANCE_INDEX: {
      screenName: "S4A_ADVANCE_INDEX",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_RELEASES_SELECTION: {
      screenName: "S4A_RELEASES_SELECTION",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_ADVANCE_PROPOSAL: {
      screenName: "S4A_ADVANCE_PROPOSAL",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_ADVANCE_FORM: {
      screenName: "S4A_ADVANCE_FORM",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_WAITING_SIGNATURE: {
      screenName: "S4A_WAITING_SIGNATURE",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_ADVANCE_CONFIRMATION: {
      screenName: "S4A_ADVANCE_CONFIRMATION",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_SIGNATURE_CONFIRMED: {
      screenName: "S4A_SIGNATURE_CONFIRMED",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_ADVANCE_WAITING_MERGE: {
      screenName: "S4A_ADVANCE_WAITING_MERGE",
      businessContext: "ADVANCE",
      platformContext,
    },
  },
  Distro: {
    S4A_DISTRO_SIGN: {
      screenName: "S4A_DISTRO_SIGN",
      businessContext: "DISTRO",
      platformContext,
    },
    S4A_DISTRO_FORM: {
      screenName: "S4A_DISTRO_FORM",
      businessContext: "DISTRO",
      platformContext,
    },
  },
  Hero: {
    S4A_HERO: {
      screenName: "SH_ENTRY",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_DETAILS: {
      screenName: "SH_DETAILS",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_SIGN_UP: {
      screenName: "SH_SIGN_UP",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_VERIFICATION: {
      screenName: "SH_VERIFICATION",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_GREETINGS: {
      screenName: "SH_GREETINGS",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_PORTAL: {
      screenName: "SH_PORTAL",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_GOODBYE: {
      screenName: "SH_GOODBYE",
      businessContext: "STRM_HERO",
      platformContext,
    },
  },
  Quincy: {
    QUINCY_HOME: {
      screenName: "QUINCY_HOME",
      businessContext: "AI_ASSISTANTS",
      platformContext,
    },
  },
};

export const dataLayerViewedEvent = (event: any) => {
  dataLayerEvent(screenViewedEventName, { ...event });
};

export const dataLayerClickedEvent = (
  buttonName:
    | HomeButtonClickEventName
    | LoginButtonClickEventName
    | QuizButtonClickEventName
    | SignUpButtonClickEventName
    | AdvanceButtonClickEventName
    | DistroButtonClickEventName
    | QuincyButtonClickEventName,
  event: any
) => {
  dataLayerEvent(clickButtonEventName, { buttonName, ...event });
};

export const dataLayerErrorEvent = (
  errorName: LoginErrorEventName,
  event: any
) => {
  dataLayerEvent("ErrorDialog", { errorName, ...event });
};
